import React from "react";

const Privacy = () => (
  <div className="bg-black text-spike-text" data-testid="privacy-page">
    <div className="max-w-3xl mx-auto px-6 py-16 lg:py-24">
      <h1 className="font-orbitron text-4xl sm:text-5xl font-black uppercase tracking-tight text-spike-text">
        Privacy <span className="text-spike-blue-light">Policy</span>
      </h1>
      <p className="mt-3 text-sm text-spike-dim font-exo">Last updated: {new Date().toISOString().slice(0, 10)}</p>

      <div className="prose prose-invert max-w-none mt-10 space-y-6 text-sm leading-relaxed text-spike-text/85 font-exo">
        <section>
          <h2 className="font-orbitron uppercase tracking-wider text-spike-blue-light text-lg">1. What we collect</h2>
          <p>
            When you create an account, book a net, sign a waiver or contact us we collect your name, email, phone
            number, date of birth (waiver only) and, for minors, a parent/guardian name. We also log standard web
            metadata such as IP address and the pages you visit.
          </p>
        </section>

        <section>
          <h2 className="font-orbitron uppercase tracking-wider text-spike-blue-light text-lg">2. How we use it</h2>
          <ul className="list-disc pl-6 space-y-1">
            <li>To create and secure your Spike Sports account.</li>
            <li>To confirm bookings, send check-in instructions and process memberships.</li>
            <li>To verify the liability waiver on file before play.</li>
            <li>To answer questions you send via the contact form.</li>
            <li>To improve the website and reply to support requests.</li>
          </ul>
        </section>

        <section>
          <h2 className="font-orbitron uppercase tracking-wider text-spike-blue-light text-lg">3. Cookies</h2>
          <p>
            We use essential cookies (e.g. <code>session_token</code>) to keep you signed in and a single localStorage
            entry to remember that you have accepted this notice. We do not use third-party advertising cookies.
          </p>
        </section>

        <section>
          <h2 className="font-orbitron uppercase tracking-wider text-spike-blue-light text-lg">4. Sharing</h2>
          <p>
            We never sell your personal data. We share data only with the service providers strictly required to
            run the platform (hosting, email delivery) and only as required by law.
          </p>
        </section>

        <section>
          <h2 className="font-orbitron uppercase tracking-wider text-spike-blue-light text-lg">5. Retention</h2>
          <p>
            Account and waiver data are retained for as long as your Spike Sports account is active and for a
            reasonable period thereafter for legal record-keeping. You may request deletion at any time by emailing us.
          </p>
        </section>

        <section>
          <h2 className="font-orbitron uppercase tracking-wider text-spike-blue-light text-lg">6. Your rights</h2>
          <p>
            You can request a copy of your personal data or its deletion by contacting
            <a href="mailto:info@spikesportscanada.com" className="text-spike-blue-light"> info@spikesportscanada.com</a>.
          </p>
        </section>

        <section>
          <h2 className="font-orbitron uppercase tracking-wider text-spike-blue-light text-lg">7. Changes</h2>
          <p>
            We will update this policy as the service evolves. Material changes will be announced via the website.
          </p>
        </section>
      </div>
    </div>
  </div>
);

export default Privacy;
